export default __webpack_public_path__ + "static/media/UG1-ag-land.a2c211cf.jpg";